module.exports = __webpack_public_path__ + "img/icon_school.dac064e3.svg";